<div class="div_loading"><div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div></div>
<div class="table-navigation">
 <table class='list-table table table-hover table-bordered table-condensed table-responsive table-striped' [ngStyle]="lang == 2 && {direction:'ltr '}">
  <tr> 
   <td style='text-align:right;direction:rtl !important' class="pe_navigation_number" colspan=10 > 
    <button (click)='change_task(1,1,"","","","")' [disabled]='new_status' *ngIf="lang == 1">جديد</button>
    <button (click)='change_task(1,1,"","","","")' [disabled]='new_status' *ngIf="lang == 2" [ngClass]="{en_navigation_number:lang==2}" >New</button>

    <button (click)='change_task(3,3,"","","","")'  *ngIf="lang == 1">جستجو</button>
    <button (click)='change_task(3,3,"","","","")'  *ngIf="lang == 2" [ngClass]="{en_navigation_number:lang==2}" >Search</button>

    <button (click)="check_access(4,4,'')"   [disabled]='next_status'><i class="fas fa-fast-forward"></i></button>
    <button (click)="check_access(4,2,'')"   [disabled]='next_status'><i class="fas fa-forward"></i></button>
    <button (click)="check_access(4,3,'')"   [disabled]='pre_status'><i class="fas fa-backward"></i></button>
    <button (click)="check_access(4,5,'')"   [disabled]='pre_status'><i class="fas fa-fast-backward"></i></button>
    <div class='navigation' [ngClass]="{en_navigation_number:lang==2}" ><span> {{ page_number_first }} </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span> {{ count_total }} </span></div>
    <span class="window_title"  *ngIf="lang == 1">ارتفاع طبقات</span>
   </td>
  </tr> 
 </table>
</div>
<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}" style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
 <mat-table  [dataSource]="dataSource"  style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'  [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}" [ngStyle]="lang == 2 && {direction:'ltr'}"> 
  <ng-container matColumnDef="row">
   <mat-header-cell *matHeaderCellDef style='max-width:70px'>
    <span *ngIf="lang == 1">ردیف</span>
    <span *ngIf="lang == 2">#</span>
   </mat-header-cell>
   <mat-cell *matCellDef="let x;let i = index"  style='max-width:70px'>{{ i + page_number_first }}</mat-cell>
  </ng-container>   
 
  <ng-container matColumnDef="title">
   <mat-header-cell *matHeaderCellDef>
    <span *ngIf="lang == 1">عنوان</span>
    <span *ngIf="lang == 2">Title</span>
   </mat-header-cell>
   <mat-cell *matCellDef="let x;let i = index">{{ x.shop_install_height_title }}</mat-cell>
  </ng-container>   

  <ng-container matColumnDef="price">
    <mat-header-cell *matHeaderCellDef>
     <span *ngIf="lang == 1">هزینه نصب</span>
    </mat-header-cell>
    <mat-cell *matCellDef="let x;let i = index">{{ x.shop_install_height_price }}</mat-cell>
   </ng-container>   

   <ng-container matColumnDef="height">
    <mat-header-cell *matHeaderCellDef>
     <span *ngIf="lang == 1">ارتفاع به متر </span>
    </mat-header-cell>
    <mat-cell *matCellDef="let x;let i = index">{{ x.shop_install_height_height }}</mat-cell>
   </ng-container>   

  <ng-container matColumnDef="status"> 
   <mat-header-cell *matHeaderCellDef>
    <span *ngIf="lang == 1"> وضعیت نمایش </span>
    <span *ngIf="lang == 2"> Status</span>
   </mat-header-cell>
   <mat-cell *matCellDef="let x;let i = index">
    <span *ngIf="lang == 1">{{ x.status_title2 }}</span>
    <span *ngIf="lang == 2">{{ x.status_title }}</span>
   </mat-cell>
  </ng-container>
	
  <ng-container matColumnDef="id" > 
   <mat-header-cell *matHeaderCellDef>
    <span *ngIf="lang == 1"> شناسه </span>
    <span *ngIf="lang == 2">Id</span> 
   </mat-header-cell>
   <mat-cell *matCellDef="let x;let i = index">{{ x.shop_install_height_id }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="operation"> 
   <mat-header-cell *matHeaderCellDef style='max-width:70px'>
    <span *ngIf="lang == 1"> عملیات </span>
    <span *ngIf="lang == 2">Operation</span>
   </mat-header-cell>
   <mat-cell *matCellDef="let x;let i = index"  style='max-width:70px'>
    <span (click)='change_task(2,x.shop_install_height_id,x.shop_install_height_title,x.shop_install_height_price,x.status_id,x.shop_install_height_height)' [hidden]='limit_forms'><i class="fas fa-desktop icon"></i></span>
    <span (click)="check_access(3,'',x.shop_install_height_id)" [hidden]='limit_forms'><i class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span> 
   </mat-cell>
  </ng-container>

   <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
   <mat-row  *matRowDef="let row;columns:displayedColumns" (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"  [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,'mat_table_hover': row === mat_table_hoverRow}"></mat-row>
 
 </mat-table>
</div>


<ngx-smart-modal #myModal identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
<form #form_myModal="ngForm">
 <div style='text-align:center;padding:12px !important' *ngIf="lang == 1 ">
  <span *ngIf="task_type==1">جديد</span>
  <span *ngIf="task_type==2">ويرايش</span> 
 </div>
 <div style='text-align:center;padding:12px !important' *ngIf="lang == 2 ">
  <span *ngIf="task_type==1">New</span>
  <span *ngIf="task_type==2">Update</span>
 </div>
 <div class="row">
  <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
   <label for="title" class='wh-label'>  
    <span *ngIf="lang == 1"> عنوان :  </span>
    <span *ngIf="lang == 2"> Title : </span>
    <input class='wh-input' name='title' [(ngModel)]='title'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off" required>
  </label>
  </div>

  <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
    <label for="title" class='wh-label'>  
     <span *ngIf="lang == 1"> هزینه نصب :  </span>
     <input class='wh-input' name='price' [(ngModel)]='price'   pattern="[0-9.]{1,}"  autocomplete="off" required>
   </label>
   </div>

   <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
    <label for="title" class='wh-label'>  
     <span *ngIf="lang == 1"> ارتفاع به متر :  </span>
     <input class='wh-input' name='height' [(ngModel)]='height'   pattern="[0-9.]{1,}"  autocomplete="off" required>
   </label>
   </div>
  
  
  <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'  [ngClass]="{en:lang==2}">
   <label for="status_id" class='wh-label'>    
    <span *ngIf="lang == 1"> وضعیت نمایش :  </span>
    <span *ngIf="lang == 2"> Status : </span>
    <select class='wh-input' name='status_id' [(ngModel)]='status_id'    pattern="[0-9]{1,}" required>
     <option value=""></option>   
     <option *ngFor='let x of list_status' value="{{ x.status_id }}">
       <span>{{ x.status_title }}</span>
      </option>
    </select>
   </label> 
  </div> 
 </div>  
 <div class="row">
  <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center' *ngIf="lang == 1 ">
   <button mat-button class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf='task_type == 1'  (click)="check_access(1,'','')" [disabled]="!form_myModal.valid">ارسال و ذخيره</button>
   <button mat-button class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf='task_type == 2'  (click)="check_access(2,'','')"  [disabled]="!form_myModal.valid">ويرايش</button> 
  </div> 
  <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center' *ngIf="lang == 2 ">
   <button mat-button class="btn_pe" [ngClass]="{btn_en:lang == 2}"  *ngIf='task_type == 1' (click)="check_access(1,'','')"  [disabled]="!form_myModal.valid" > Save </button>
   <button mat-button class="btn_pe" [ngClass]="{btn_en:lang == 2}"  *ngIf='task_type == 2' (click)="check_access(2,'','')"   [disabled]="!form_myModal.valid">Update</button>
  </div>
 </div>
</form>
</ngx-smart-modal>

<ngx-smart-modal #myModalSearch identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
<form #myModalSearch="ngForm">    
 <div style='text-align:center;padding:12px !important' *ngIf="lang == 1 ">جستجو</div>
 <div style='text-align:center;padding:12px !important' *ngIf="lang == 2 ">Search</div>
 <div class="row">
  <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
   <label for="title" class='wh-label'>  
    <span *ngIf="lang == 1"> عنوان :  </span>
    <span *ngIf="lang == 2"> Title :  </span>
    <input class='wh-input' name='title_search' [(ngModel)]='title_search' pattern="[{{ pattern_title_with_persian }}]{1,}" autocomplete="off">
   </label>
  </div>
  <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'  [ngClass]="{en:lang==2}">
    <label for="status_id" class='wh-label'>    
      <span *ngIf="lang == 1"> وضعيت نمايش :  </span>
      <span *ngIf="lang == 2">  Status :  </span>
     <select class='wh-input' name='status_id_search' [(ngModel)]='status_id_search'    pattern="[0-9]{1,}">
      <option value=""></option>   
      <option *ngFor='let x of list_status' value="{{ x.status_id }}">
        <span>{{ x.status_title }}</span>
       </option>
     </select>
    </label> 
  </div> 
   
 </div>
 <div class="row">
  <div class='col-xl-12 col-lg-12  col-md-12  col-sm-12 col-xs-12' style='margin-top:5px;text-align:center;font-family:irsans' *ngIf="lang == 1 ">
   <button mat-button class="btn_pe" [ngClass]="{btn_en:lang == 2}"  (click)="check_access(4,6,'')">جستجو</button>
  </div>
  <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center;font-family:en' *ngIf="lang == 2 ">
   <button mat-button class="btn_pe" [ngClass]="{btn_en:lang == 2}"  (click)="check_access(4,6,'')">Search</button>
  </div>
 </div>
</form>
</ngx-smart-modal>
